import type { ProfessionalOnlineStatus } from '@klaro7/shared-types';

const statusConfig: Record<ProfessionalOnlineStatus, { color: string; label: string }> = {
  online: { color: 'bg-green-500', label: 'Online' },
  busy: { color: 'bg-yellow-500', label: 'Occupato' },
  offline: { color: 'bg-neutral-400', label: 'Offline' },
  paused: { color: 'bg-brand-orange', label: 'In pausa' },
};

interface AvailabilityBadgeProps {
  status: ProfessionalOnlineStatus;
  showLabel?: boolean;
  size?: 'sm' | 'md';
  variant?: 'light' | 'dark';
}

export function AvailabilityBadge({ status, showLabel = false, size = 'sm', variant = 'light' }: AvailabilityBadgeProps) {
  const config = statusConfig[status];
  const dotSize = size === 'sm' ? 'h-2.5 w-2.5' : 'h-3 w-3';
  const labelColor = variant === 'dark' ? 'text-white/70' : 'text-neutral-600';

  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="relative flex">
        <span className={`${dotSize} rounded-full ${config.color}`} />
        {status === 'online' && (
          <span className={`absolute inset-0 ${dotSize} animate-ping rounded-full ${config.color} opacity-75`} />
        )}
      </span>
      {showLabel ? (
        <span className={`text-xs font-medium ${labelColor}`}>{config.label}</span>
      ) : (
        <span className="sr-only">{config.label}</span>
      )}
    </span>
  );
}
